<template>
  <el-container class="layout-container">
    <el-aside width="248px" class="sidebar">
      <div class="logo">
        <div class="brand-block">
          <div class="brand-mark" aria-hidden="true">
            <img :src="brandLogo" alt="平台 Logo" class="brand-mark-image" />
          </div>
          <h3>{{ dspTitle }}</h3>
        </div>
      </div>
      <div class="customer-switcher">
        <div class="switcher-label">当前客户</div>
        <el-select
          :value="activeCustomerId"
          popper-class="customer-popper"
          placeholder="选择客户"
          @change="handleCustomerChange">
          <el-option
            v-for="customer in customers"
            :key="customer.id"
            :label="customer.name"
            :value="customer.id">
            <div class="customer-option">
              <span class="customer-dot" :style="{ backgroundColor: customer.theme }"></span>
              <span>{{ customer.name }}</span>
            </div>
          </el-option>
        </el-select>
      </div>
      <el-menu
        router
        :default-active="$route.path"
        class="sidebar-menu"
        background-color="transparent"
        text-color="#d8e1ff"
        active-text-color="#ffffff">
        <el-menu-item index="/dashboard">
          <i class="el-icon-s-home"></i>
          <span>仪表盘</span>
        </el-menu-item>
        <el-menu-item index="/reports">
          <i class="el-icon-data-analysis"></i>
          <span>报表中心</span>
        </el-menu-item>
        <el-menu-item index="/campaigns">
          <i class="el-icon-s-marketing"></i>
          <span>广告计划</span>
        </el-menu-item>
        <el-menu-item index="/materials">
          <i class="el-icon-folder-opened"></i>
          <span>物料管理</span>
        </el-menu-item>
        <el-menu-item index="/media-slots">
          <i class="el-icon-monitor"></i>
          <span>媒体代码位</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    
    <el-container>
      <el-header>
        <div class="header-wrapper">
          <h3 class="title">{{ title }}</h3>
          <div class="user-info">
            <span>{{ accountName }}</span>
            <el-button type="text" @click="logout" class="logout-btn">
              <i class="el-icon-switch-button"></i> 退出登录
            </el-button>
          </div>
        </div>
      </el-header>
      
      <el-main>
        <div class="main-shell">
          <slot></slot>
          <div v-if="icpLicenseNo" class="page-icp">
            {{ icpLicenseNo }}
          </div>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import brandLogo from '@/assets/logo.png'

export default {
  name: 'Layout',
  data() {
    return {
      brandLogo,
      titleMap: {
        '/dashboard': '仪表盘',
        '/reports': '报表中心',
        '/campaigns': '广告计划列表',
        '/campaigns/create': '创建广告计划',
        '/campaigns/edit': '编辑广告计划',
        '/materials': '物料管理',
        '/media-slots': '媒体代码位管理'
      }
    }
  },
  computed: {
    ...mapState(['customers', 'activeCustomerId']),
    ...mapGetters(['activeCustomer']),
    dspTitle() {
      return this.$dspTitle || '艾克斯广告平台'
    },
    title() {
      const path = this.$route.path
      for (const key in this.titleMap) {
        if (path.startsWith(key)) {
          return this.titleMap[key]
        }
      }
      return `${this.dspTitle} 管理后台`
    },
    currentCustomerName() {
      return this.activeCustomer ? this.activeCustomer.name : ''
    },
    accountName() {
      if (typeof window === 'undefined') {
        return '管理员账户'
      }
      return localStorage.getItem('accountName') || '管理员账户'
    },
    icpLicenseNo() {
      return this.$icpLicenseNo || ''
    }
  },
  created() {
    // 如果还没有DSP配置，尝试获取
    if (!this.$dspTitle) {
      this.$getDspConfig()
    }
  },
  methods: {
    async handleCustomerChange(customerId) {
      this.$store.dispatch('setActiveCustomer', customerId)
      await this.$store.dispatch('refreshCustomerData')
      const customer = this.customers.find(item => item.id === customerId)
      if (customer) {
        this.$message.success(`已切换至 ${customer.name}`)
      }
    },
    logout() {
      localStorage.removeItem('isAuthenticated'); // 清除登录状态
      localStorage.removeItem('accountName');
      this.$router.push('/login'); // 跳转到登录页
      this.$message.success('已成功登出');
    }
  }
}
</script>

<style scoped>
.layout-container {
  height: 100%;
  background:
    radial-gradient(circle at top left, rgba(60, 104, 255, 0.18), transparent 32%),
    linear-gradient(180deg, #f4f7ff 0%, #eef2fb 100%);
}

.sidebar {
  background:
    linear-gradient(180deg, #091326 0%, #13284a 48%, #101d34 100%);
  color: white;
  box-shadow: 18px 0 48px rgba(6, 16, 37, 0.16);
  padding: 18px 14px;
  box-sizing: border-box;
}

.logo {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #f4f7ff;
  padding: 6px 10px 14px;
}

.brand-block {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand-mark {
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 10px 24px rgba(4, 10, 24, 0.22);
  flex-shrink: 0;
}

.brand-mark-image {
  width: 28px;
  height: 28px;
  display: block;
  object-fit: contain;
}

.brand-block h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.2;
}

.customer-switcher {
  margin: 10px 6px 18px;
  padding: 14px;
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.04));
  border: 1px solid rgba(171, 194, 255, 0.14);
  backdrop-filter: blur(12px);
}

.switcher-label {
  font-size: 12px;
  color: #9fb2e2;
  margin-bottom: 8px;
}

.sidebar ::v-deep .el-input__inner {
  background: rgba(7, 18, 39, 0.85);
  border: 1px solid rgba(159, 178, 226, 0.28);
  color: #f4f7ff;
  border-radius: 12px;
}

.sidebar ::v-deep .el-input__suffix {
  color: #d8e1ff;
}

.sidebar-menu {
  border-right: none;
}

.sidebar-menu ::v-deep .el-menu-item {
  height: 52px;
  line-height: 52px;
  border-radius: 14px;
  margin-bottom: 8px;
  transition: all 0.22s ease;
}

.sidebar-menu ::v-deep .el-menu-item:hover {
  background: rgba(255, 255, 255, 0.08) !important;
}

.sidebar-menu ::v-deep .el-menu-item.is-active {
  background: linear-gradient(90deg, rgba(51, 122, 255, 0.92), rgba(25, 179, 255, 0.86)) !important;
  box-shadow: 0 12px 22px rgba(20, 89, 215, 0.26);
}

.el-header {
  background: rgba(255, 255, 255, 0.74);
  box-shadow: 0 10px 28px rgba(16, 29, 52, 0.06);
  backdrop-filter: blur(14px);
  padding: 0 28px;
}

.el-main {
  padding-bottom: 18px;
}

.main-shell {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.page-icp {
  margin-top: auto;
  padding: 20px 0 4px;
  text-align: center;
  font-size: 12px;
  line-height: 1.6;
  color: #7d879b;
}

.header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.title {
  margin: 0;
  font-weight: 600;
  color: #14213d;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 14px;
  color: #54627f;
  font-size: 14px;
}

.logout-btn {
  color: #409EFF;
}

.customer-option {
  display: flex;
  align-items: center;
  gap: 10px;
}

.customer-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex: 0 0 9px;
}
</style> 
